import { NavLink } from 'react-router-dom'
export default function SectionNav({ items }: { items: { id: string; label: string }[] }) {
  return <nav className="section-nav" aria-label="On this page">
    {items.map(item => <a key={item.id} href={`#${item.id}`}>{item.label}</a>)}
  </nav>
}
export function NotFound() {
  return <div className="empty"><span className="platform-eyebrow">404 · PAGE NOT FOUND</span>
    <h1>This page isn’t here</h1><p>The address may have changed. Return to your workspace to continue.</p>
    <NavLink className="btn primary" to="/">Back to overview</NavLink>
  </div>
}
